/*
 * 功能名称: 功能描述
 * 创 建 人: 程天乐
 * 日    期: 2024-04-26 19:29:04
 */
import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class CoreInstitutionmodulerelationApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'core-institutionmodulerelation'
    }

    /**
     * 查询列表
     * @param params
     * @returns 
     */
    public getListByParams(params) {
        return this.send(params, "getListByParams", Methods.GET)
    }

    /**
     * 根据条件删除
     * @param params
     * @returns 
     */
        public deleteByParams(params) {
            return this.send(params, "deleteByParams", Methods.POST)
        }    
}